module.exports = __webpack_public_path__ + "images/emoji/vhs.290cf83cb7d8aed531b0.png";